import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { IUser, IConfigApp } from 'kts-platform-frame/redux/ReduxState';
import { Aside } from 'kts-platform-frame/display/part';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import ModulesRoute from './Modules.Route';
import UIFeatures from './UI.Features';
import UIAide from './UI.Aide';
import UILog from './UI.Log';
import UIAppError from './UI.AppError';
import UIUserPanel from './UI.UserPanel';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Layout } from 'antd';
import TotalModulesAction from '../Modules.Action';

const { Content, Sider } = Layout;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    user: IUser;
    appMap: Map<string, IConfigApp>;
    loadingUrls: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@connect((state: ReduxState): IReduxStatePart => ({
    user: state.user,
    appMap: state.config.appList.map,
    loadingUrls: state.system.loadingUrls,
}))
export default class Workbench extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    /** 当前路径 */
    private pathname: string = null;

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    render() {
        if (this.redirection() === false) {
            return null;
        }

        return (
            <ModulesRoot action={ModulesAction}>
                <Layout>
                    <Sider
                        collapsed={this.state.collapsed}
                        className={css.layout}
                        collapsedWidth={64}
                        width={180}
                        trigger={null}
                        collapsible={true}
                    >
                        <div
                            id="kes-menu-container"
                            style={{
                                width: this.state.collapsed ? 64 : 180,
                                paddingBottom: this.state.collapsed ? 178 : 155,
                            }}
                        >
                            {/* 图标和收折按钮 */}
                            <UILog />

                            {/* 基础功能 */}
                            <UIFeatures />

                            <div className={css.separation} />

                            {/* 辅助功能 */}
                            <UIAide />

                            {/* 用户面板 */}
                            <UIUserPanel />
                        </div>
                    </Sider>

                    {/* 核心内容 */}
                    {this.coreContent}

                    {/* 侧边栏 */}
                    <Aside />
                </Layout>
            </ModulesRoot>
        );
    }

    /** 核心内容  */
    private get coreContent(): JSX.Element {
        // 是否发生错误
        if (this.state.isError) {
            return (
                <Content className={css.content} >
                    <UIAppError />;
                </Content>
            );
        } else {
            return (
                <Content className={css.content} >
                    {ModulesRoute.getChildReact()}
                </Content>
            );
        }
    } 

    /** 根据登录状态跳转 */
    private redirection = (): boolean => {
        const { history, user } = this.props;
        if (!user.cToken) {
            if (window.location.href) {
                history.push(`/login?redirectURL=${escape(window.location.pathname + window.location.search + window.location.hash)}`);
            } else {
                history.push(`/login`);
            }
            return false;
        } else {
            return true;
        }
    }
}




// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/index.tsx